/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Trend_ImprovingInputs */

const en_us2_profile_editors_pain_trend_improving = /** @type {(inputs: Profile_Editors_Pain_Trend_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Improving`)
};

const pt_br2_profile_editors_pain_trend_improving = /** @type {(inputs: Profile_Editors_Pain_Trend_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhorando`)
};

const es_419_profile_editors_pain_trend_improving = /** @type {(inputs: Profile_Editors_Pain_Trend_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorando`)
};

const pt_pt2_profile_editors_pain_trend_improving = /** @type {(inputs: Profile_Editors_Pain_Trend_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A melhorar`)
};

const fr_fr2_profile_editors_pain_trend_improving = /** @type {(inputs: Profile_Editors_Pain_Trend_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça s'améliore`)
};

const de_de2_profile_editors_pain_trend_improving = /** @type {(inputs: Profile_Editors_Pain_Trend_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird besser`)
};

const it_it2_profile_editors_pain_trend_improving = /** @type {(inputs: Profile_Editors_Pain_Trend_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliora`)
};

/**
* | output |
* | --- |
* | "Improving" |
*
* @param {Profile_Editors_Pain_Trend_ImprovingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_trend_improving = /** @type {((inputs?: Profile_Editors_Pain_Trend_ImprovingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Trend_ImprovingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_trend_improving(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_trend_improving(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_trend_improving(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_trend_improving(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_trend_improving(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_trend_improving(inputs)
	return en_us2_profile_editors_pain_trend_improving(inputs)
});
export { profile_editors_pain_trend_improving as "profile-editors.pain_trend_improving" }